import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import adminRoutes from "routes/admin-routes";
import PageHeader from "./sections/PageHeader";
import MKBox from "components/MKBox";
import footerRoutes from "footer.routes";
import DefaultFooter from "components/DefaultFooter";
import ContainerCard from "components/ContainerCard";

import Container from "@mui/material/Container";
import ChatDetails from "./sections/ChatDetails";
import MessageList from "./sections/MessageList";

function ChatsDatabase() {
  return (
    <>
      <DefaultNavbar routes={adminRoutes} />
      <PageHeader />
      <ContainerCard>
        <Container>
          <ChatDetails />
          <MessageList />
        </Container>
      </ContainerCard>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ChatsDatabase;
